import { LoadableRoute } from 'routes/utils/loadable';

export const UserMessengerContainer = LoadableRoute({
  loader: () =>
    import(/* webpackChunkName: "UserMessenger" */ './UserMessenger'),
});
